import { API } from '@aws-amplify/api'
import { getUserProfile } from '../actions'
import { WOMA_API_GATEWAY_NAME } from '../../constants/aws'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const fetchUserProfileData = (id) => async (dispatch) => {
  const apiName = `user-management/users/${id}`
  try {
    const options = {
      headers: {},
      response: false,
    }
    const result = await API.get(WOMA_API_GATEWAY_NAME, `/${apiName}`, options)
    if (result?.data) {
      dispatch(getUserProfile({ payload: result }))
    }
  } catch (err) {
    dispatch(getUserProfile({ payload: 'GET_USER_PROFILE_DATA_ERROR' }))
    console.log('Cases Error', err)
  }
}
